export class ViewCommentConstants {
    static TITLE_LBL = "View Comment";
    static NAME_LABEL = "Comment Name";
    static BUSINESS_UNIT_LABEL = "Business Unit";
    static CAPTURE_DATE_LABEL = "Captured Date";
    static CAPTURE_BY_LABEL = "Captured By";
    static COMMENT_TYPE_LABEL = "Comment Type";
    static EMAIL_LABEL = "Email";
    static CONTACTNO_LABEL = "Contact Number";
    static COMMENT_TEXT_LABEL = "Comment";
    static ATTACHMENT_LABEL = "Attachments";
    static REVIEW_STATUS_LABEL = "Review Status";
    static REVIEW_NOTE_LABEL = "Rejection Reason";
    static REVIEW_BY_USER_LABEL = "Reviewed By";
    static REVIEW_BY_DATE_LABEL = "Review Date";
    static COMMENT_NOT_REVIEWED = "Comment has not been reviewed";
}
